import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Stack, styled, Typography } from "@mui/material";
import { isNotUndefinedOrNull } from "../FunctionsCore";
import { ForwardArrow } from "../icons/forward";
import { FONTSTYPO, SPACING } from "../theme/palette";
import circle from "./resources/circle.svg";
import heroMask from "./resources/hoovers-pdp-hero-mask.svg";
import heroPattern from "./resources/hoovers-pdp-hero-pattern.svg";
const BannerStyle = styled("div")(({ pattern, theme }) => ({
    ":after": {
        "backgroundColor": theme.palette.primary.dark,
        "content": "' '",
        "display": "block",
        "gridColumn": "1",
        "gridRow": "image",
        "maskImage": `url(${circle})`,
        "maskPosition": "25% 105%",
        "maskRepeat": "no-repeat",
        "maskSize": "200%",
        "z-index": "0"
    },
    "@media screen and (min-width: 55rem)": {
        "--grid-max-width": "55rem",
        ":after": {
            "backgroundImage": `url(${pattern})`,
            "backgroundPosition": "bottom right",
            "backgroundRepeat": "no-repeat",
            "blockSize": "100%",
            "content": '" "',
            "display": "block",
            "gridColumn": "1/-1",
            "gridRow": "1",
            "maskImage": `url(${heroMask})`,
            "maskPosition": "bottom right",
            "maskRepeat": "no-repeat",
            "maskSize": "545px auto",
            "z-index": "0"
        },
        "gap": "0",
        "gridTemplateColumns": "[full-start] minmax(0,1fr) [gutter-left] minmax(0,21.25rem) [content-start] calc(var(--grid-max-width)/ 2) [content-mid] calc(var(--grid-max-width)/ 2) [content-end] minmax(0,21.25rem) [gutter-right] minmax(0,1fr) [full-end]",
        "padding": 0,
    },
    "@media screen and (min-width: 77rem)": {
        "--grid-max-width": "77.50rem",
        "gridTemplateColumns": "[full-start] minmax(0,1fr) [gutter-left] minmax(0,21.25rem) [content-start] calc(var(--grid-max-width)/ 2) [content-mid] calc(var(--grid-max-width)/ 2) [content-end] minmax(0,21.25rem) [gutter-right] minmax(0,1fr) [full-end]",
    },
    "backgroundColor": "transparent",
    "color": theme.palette.primary.dark,
    "display": "grid",
    "gridTemplateColumns": " 1fr",
    "gridTemplateRows": "[text-start] auto [text-end image-start] auto [image-end]"
}));
const TextContainer = styled("div")(({ theme }) => ({
    "@media screen and (min-width: 55rem)": {
        "--grid-gutter": "var(--space , clamp(0.75rem, calc(0.57rem + 0.88vw), 1.25rem))",
        "--space": SPACING.spacexss,
        "backgroundColor": "transparent",
        "color": theme.palette.common.black,
        "gridColumn": "content-start/content-mid",
        "gridRow": "1",
        "padding": `calc(${SPACING.space3xl} * 2) var(--grid-gutter)`,
    },
    "backgroundColor": theme.palette.primary.dark,
    "color": theme.palette.common.white,
    "gridColumn": "1",
    "gridRow": "text",
    "padding": `${SPACING.spacexl} ${SPACING.spaces}`,
    "zIndex": "1",
}));
const ProductNameStyle = styled(Typography)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.h1), { "@media screen and (min-width: 55rem)": {
        "color": theme.palette.primary.dark,
        "fontSize": `clamp(${FONTSTYPO.step1}, calc(.5rem + 4vw), ${FONTSTYPO.step4})`,
    }, "fontWeight": 350, "lineHeight": 1.2 })));
const subheadingOverRide = {
    "fontSize": `clamp(${FONTSTYPO.step0}, calc(1rem + 3vw), ${FONTSTYPO.step1})`
};
const ActionStyle = styled(Button)(({ theme }) => ({
    "&:hover": {
        "backgroundColor": theme.palette.grey[400],
        "color": theme.palette.primary.dark,
    },
    "@media screen and (min-width: 55rem)": {
        "&:hover": {
            "backgroundColor": theme.palette.primary.dark,
            "color": theme.palette.common.white,
        },
        "backgroundColor": theme.palette.primary.main,
        "color": theme.palette.common.white,
    },
    "backgroundColor": theme.palette.common.white,
    "color": theme.palette.primary.dark,
    "marginBlock": theme.spacing(2.5),
    [theme.breakpoints.down("sm")]: {
        "width": "100%"
    }
}));
const HeroImageStyle = styled("div")(() => ({
    "@media screen and (min-width: 55rem)": {
        "--grid-gutter": "var(--space , clamp(0.75rem, calc(0.57rem + 0.88vw), 1.25rem))",
        "--space": SPACING.spacexss,
        "alignItems": "center",
        "display": "flex",
        "gridColumn": "content-mid/gutter-right",
        "gridRow": "1",
        "padding": `${SPACING.space3xl} var(--grid-gutter)`,
        "zIndex": "1"
    },
    "gridColumn": "1",
    "gridRow": "image",
    "img": {
        "height": "auto",
        "inlineSize": "100%",
        "maxInlineSize": "100%",
        "position": "relative",
        "zIndex": "1",
    },
}));
const BreadCrumbStyle = styled(Typography)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.caption), { "@media screen and (min-width: 55rem)": {
        "color": theme.palette.primary.main
    }, "fontWeight": 600 })));
export const ProductDetailsHeroComponent = (props) => {
    const { cta, actionItemHandler, productFamilyHeroBreadcrumb, productFamilyHeroButtonText, productFamilyHeroImage, productFamilyHeroPrimaryHeading, productFamilyHeroSecondaryHeading, productFamilybgPattern } = props;
    return (_jsxs(BannerStyle, Object.assign({ pattern: isNotUndefinedOrNull(productFamilybgPattern) ? productFamilybgPattern : heroPattern }, { children: [_jsxs(TextContainer, { children: [_jsxs(Stack, Object.assign({ direction: "column", spacing: 2.5 }, { children: [_jsx(BreadCrumbStyle, { children: productFamilyHeroBreadcrumb }), _jsx(ProductNameStyle, { children: productFamilyHeroPrimaryHeading }), _jsx(Typography, Object.assign({ sx: Object.assign({}, subheadingOverRide), variant: "h5" }, { children: productFamilyHeroSecondaryHeading }))] })), isNotUndefinedOrNull(productFamilyHeroButtonText) ? (_jsxs(ActionStyle, Object.assign({ className: isNotUndefinedOrNull(cta) && isNotUndefinedOrNull(cta.className) ? cta.className : "", color: "inherit", onClick: actionItemHandler, size: "large", variant: "contained" }, { children: [productFamilyHeroButtonText, " ", _jsx(ForwardArrow, {})] }))) : _jsx(_Fragment, { children: " " })] }), _jsx(HeroImageStyle, { children: _jsx("img", { alt: productFamilyHeroPrimaryHeading, src: productFamilyHeroImage }) })] })));
};
